document.addEventListener("DOMContentLoaded", function () {
    var linkToggle = document.querySelectorAll('[data-toggle-title]');
    var height = 0;

    linkToggle.forEach(function(e) {
        e.addEventListener('click', function (event) {

            event.preventDefault();

            var container = this.nextElementSibling;

            if (!container.classList.contains('active')) {

                this.classList.add('active');
                container.classList.add('active');
                container.style.height = 'auto';

                height = container.scrollHeight + 30 + 'px';

                container.style.height = '0px';

                setTimeout(function () {
                    container.style.height = height;
                }, 0);

            } else {

                this.classList.remove('active');
                container.style.height = '0px';

                container.addEventListener('transitionend', function () {
                    container.classList.remove('active');
                }, {
                    once: true
                });

            }

        });
    });
});